import axios from "axios";

// Serve all API calls from the SAME ORIGIN the app is loaded from so the httpOnly
// `access_token` cookie (SameSite=Lax, host-only) stays first-party across the Emergent
// production domain AND custom domains (e.g. streamccs.com). Falls back to the build-time
// REACT_APP_BACKEND_URL when no browser origin is available (SSR/build).
const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : CONFIGURED_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies solely on the httpOnly `access_token` cookie (set by the backend).
// withCredentials ensures the cookie is sent on every request. We intentionally do
// NOT read/store the JWT in localStorage (XSS-exfiltration risk).
export const api = axios.create({ baseURL: API, withCredentials: true });

// Canonical PAS playback entry point. Clients NEVER construct manifest/provider URLs — they
// request a session-scoped playbackUrl from the public Playback Bootstrap endpoint and hand it
// straight to their HLS player. Returns the playbackUrl string (throws on non-live/unauthorized).
export async function getPlaybackUrl(channelId, opts = {}) {
  const { data } = await api.post("/playback/bootstrap", {
    channel_id: channelId,
    platform: opts.platform || "web",
  });
  return data.playbackUrl;
}

// Permanent, per-channel Distribution URL (HLS) — the operational distribution endpoint external
// apps (ReVine TV Web/Android/Roku) point at. Deterministic from the channel id (no network call).
// This is the primary copyable artifact operators hand off; PAS bootstrap remains the canonical
// authenticated playback contract used for in-app Live Preview.
export function getDistributionUrl(channelId) {
  return `${API}/manifest/${channelId}.m3u8`;
}

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtDuration(seconds) {
  seconds = Math.round(seconds || 0);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  if (m > 0) return `${m}m ${String(s).padStart(2, "0")}s`;
  return `${s}s`;
}
